/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-28 13:59:38
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-15 18:50:00
 */

import * as request from '@/utils/request'

export default {
  /**
   * getContractList
   * @description 合同列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminContractList(data) {
    return request.post('/admin_contract/list', data)
  },
  /**
   * saveContract
   * @description 保存合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveAdminContractAudit(data) {
    return request.post('/admin_contract/audit', data)
  },
  /**
   * deleteContract
   * @description 删除合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAdminContract(id) {
    let data = {id:id}
    return request.post('/admin_contract/delete', data)
  },
}